import React, { useState } from 'react';
import logoZkcandy from '../assets/logo-zkcandy.svg';
import iconMenu from '../assets/icon-menu.svg';
import iconClose from '../assets/icon-close.svg';
import iconDiscord from '../assets/icon-header-discord.webp';
import iconTelegram from '../assets/icon-header-telegram.webp';
import iconX from '../assets/icon-header-x.webp';
import iconGamecenter from '../assets/icon-header-gamecenter.webp';
import { Link } from 'react-router-dom';
import { useAppKit, useAppKitAccount } from '@reown/appkit/react';

export default function Header() {
  const { isConnected } = useAppKitAccount();
  const { open } = useAppKit();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(prevState => !prevState);
  };

  const nav = [
    {
      name: 'Portal',
      link: 'https://portal.zkcandy.io',
    },
    {
      name: 'Passport',
      link: 'https://passport.zkcandy.io',
    },
  ]

  const socialLinks = [
    {
      href: "https://t.me/zkcandygame_bot",
      img: iconGamecenter,
      alt: "ZKcandy Game Center"
    },
    {
      href: "https://discord.com/invite/zkcandy",
      img: iconDiscord,
      alt: "ZKcandy Discord"
    },
    {
      href: "https://x.com/ZKcandyHQ",
      img: iconX,
      alt: "ZKcandy X"
    },
    {
      href: "https://t.me/zkcandy",
      img: iconTelegram,
      alt: "ZKcandy Telegram"
    }
  ];

  return (
    <nav className='navbar py-3 xl:py-4 text-white font-bold uppercase bg-black bg-opacity-60'>
      <div className="container mx-auto">
        <div className='flex items-center justify-between px-3'>
          <Link to="https://zkcandy.io/" target='_blank' rel="noreferrer noopener" className='logo xl:w-[180px] w-[120px] hover:scale-[1.1] eas-in duration-300'>
            <img className='w-full' src={logoZkcandy} alt='Logo' />
          </Link>

          <div className="xl:hidden z-[11] w-8 h-8" onClick={toggleMenu}>
            {isMenuOpen ? (
              <img className='close' src={iconClose} alt='close' />
            ) : (
              <img className='menu' src={iconMenu} alt='menu' />
            )}
          </div>

          <div className={`${isMenuOpen ? 'menu-container show' : 'menu-container '} transition-all duration-300 w-full flex xl:flex-row flex-col justify-between items-center xl:pb-0 pb-20 md:top-[50px] top-[45px]`}>
            <div className='menu flex items-center xl:flex-row flex-col xl:ml-10 xl:space-x-8 xl:space-y-0 space-y-8 xl:mb-0 mb-10'>
              <Link onClick={toggleMenu} to="/" className="font-black uppercase flex items-center hover:text-[#FF00C8] text-[1.1rem]">Home</Link>
              {nav.map((item, index) => (
                <a onClick={toggleMenu} key={index} href={item.link} className="flex items-center hover:text-[#FF00C8] text-[1.1rem]" target="_blank" rel="noreferrer noopener">
                  <span className="font-black uppercase">{item.name}</span>
                </a>
              ))}
            </div>

            <div className="flex xl:flex-row flex-col items-center">
              <div className="menu flex items-center flex-row space-x-2 xl:order-2 order-2 xl:mt-0 mt-10">
                {socialLinks.map((item, idx) => (
                  <a key={idx} onClick={toggleMenu} href={item.href} target="_blank" rel="noreferrer noopener">
                    <img src={item.img} alt={item.alt} />
                  </a>
                ))}
              </div>
              <div className="flex flex-col xl:flex-row xl:ml-3 xl:space-x-3 xl:space-y-0 space-y-2 xl:order-2 order-1">
                <a href="https://zkcandy.notion.site/KRO-CANDY-TOKEN-SWAP-TERMS-OF-SERVICE-1f8514dde58280f0a383d441ec5fa968" target="_blank" rel="noreferrer noopener" className="bg-white text-black font-black uppercase p-2 rounded-md">Swap Vesting T&C</a>
                <div className="flex justify-center">
                  {!isConnected ? (
                    <button onClick={() => open({ view: 'Connect' })} className="bg-purple-600 text-white font-black italic p-2 border border-white rounded-md uppercase font-jetbrains">
                      Connect Wallet
                    </button>
                  ) : (
                    <appkit-account-button />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}